
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetobhimashankarcab() {



    const cardData =
    {
        keyword: 'Pune to Bhimashankar Cab',
        heading: 'Meghana Cab : Pune to Bhimashankar Cab',
        headingDescription: 'Meghana Cab offers Pune to Bhimashankar Cab services, making your journey to the revered Bhimashankar Temple comfortable, safe, and serene. Whether you are visiting for a spiritual retreat, trek, or family outing, our clean and well-maintained cabs with experienced drivers ensure a smooth and punctual ride. Choose from a variety of vehicle options based on your group size and preferences, and benefit from transparent pricing, 24/7 customer support, and hassle-free booking. Book your Pune to Bhimashankar Cab with Meghana Cab and enjoy a peaceful pilgrimage with convenience and care.',


        top: 'Top Places to Visit in Bhimashankar with Meghana Cab',

"topPlaces": [
  {
    "title": "Bhimashankar Temple",
    "description": "One of the twelve Jyotirlingas of Lord Shiva, this 13th-century Nagara-style temple sits at around 1,050 m elevation in the Sahyadri hills. Its carved Shiva lingam, historic bell donated by Chimaji Appa, and serene riverside location make it both architecturally and spiritually significant."
  },
  {
    "title": "Bhimashankar Wildlife Sanctuary",
    "description": "Covering approximately 131 km², this sanctuary preserves the rare Indian giant squirrel and diverse wildlife such as leopards, sambhar deer, barking deer, and numerous bird species. Set amid dense Western Ghats forests and tribal villages, it is a biodiversity hotspot and scenic trekker’s paradise."
  },
  {
    "title": "Bhimashankar Trek (Shidi and Ganesh Ghats)",
    "description": "The trek from Khandas village climbs to the temple via two main routes—Shidi Ghat (steeper, laddered, 3.5 h) and Ganesh Ghat (gentler, 4 h). The approximately 7–8 km trail passes through evergreen forest, streams, ladders, and rocky outcrops, offering spectacular views."
  },
  {
    "title": "Hanuman Lake",
    "description": "A peaceful hill lake located a short walk above the temple complex. Surrounded by forest, it is popular among visitors seeking a quiet spot for reflection and brief picnics amidst nature."
  },
  {
    "title": "Ahupe Waterfall",
    "description": "A seasonal waterfall located within the sanctuary limits. Best witnessed during or after the monsoon rains, it's a refreshing stopover point on the way in or out of the Bhimashankar region."
  },
  {
    "title": "Gupt Bhimashankar Shrine",
    "description": "An ancient hidden cave shrine believed to be the original spot of the Jyotirlinga. Accessible via a short but steep forest trail, it offers a poignant spiritual site amid the dense forest canopy."
  },
  {
    "title": "Nagphani Point (Cobra’s Hood)",
    "description": "A rocky outcrop offering elevated jungle and valley views, so named for its cobra-hood-like rock formation. A favorite lookout for trekkers and photographers exploring shrine-forest circuits."
  },
  {
    "title": "Bhorgiri Fort",
    "description": "Ruins of an old hill fort located about 7 km from the main temple. The moderate trek through forested terrain rewards visitors with panoramic views of the Sahyadri ridges and nearby Bhima River valley."
  },
  {
    "title": "Junnar Caves (Manmodi Caves)",
    "description": "About 50 km from Bhimashankar, these ancient Buddhist–Hindu rock-cut caves include the Manmodi group with 2nd-century CE inscriptions. They provide insight into early trade-route architecture and religious practices."
  },
  {
    "title": "Shivneri Fort",
    "description": "Near Junnar, this fort is the birthplace of Chhatrapati Shivaji Maharaj. With its high plateau, historical ruins, and strategic vantage points, it offers a mix of nature, heritage, and trekking challenge."
  }
],

"services": [
    {
        "name": "Pune to Bhimashankar Temple Cab",
        "description": "Book a comfortable and reliable cab from Pune to Bhimashankar Temple with Meghana Cab. Enjoy a spiritual journey through scenic ghats and dense forest roads, with our experienced drivers ensuring a safe and peaceful ride to one of Maharashtra’s most revered Jyotirlingas."
    },
    {
        "name": "Bhimashankar Darshan Taxi from Pune",
        "description": "Plan your Bhimashankar Darshan with ease using Meghana Cab’s dedicated taxi service. Our well-maintained vehicles and courteous drivers make your pilgrimage stress-free, with smooth pickup and drop services and ample time at the temple for darshan and pooja."
    },
    {
        "name": "Cab Hire Pune to Bhimashankar",
        "description": "Looking to hire a cab for your trip to Bhimashankar from Pune? Meghana Cab offers a range of options including hatchbacks, sedans, and SUVs. Our cab hire service is ideal for both solo travelers and groups, with clean vehicles and professional drivers at your service."
    },
    {
        "name": "One Way Taxi Pune to Bhimashankar",
        "description": "Need a one-way ride to Bhimashankar? Meghana Cab provides affordable and convenient one-way taxi services from Pune to Bhimashankar. Perfect for those planning to stay at the temple or return by other means, our service is available round the clock."
    },
    {
        "name": "Round Trip Cab Pune to Bhimashankar",
        "description": "Enjoy a complete Bhimashankar experience with our round trip cab service from Pune. Perfect for day trips and weekend getaways, our round trip option includes return travel with flexible halts, comfortable seating, and an experienced chauffeur."
    },
    {
        "name": "AC Cab Booking to Bhimashankar",
        "description": "Travel in comfort with Meghana Cab’s AC cab services to Bhimashankar. Our vehicles are equipped with climate control and plush seating, making the hilly terrain ride pleasant even during warmer seasons."
    },
    {
        "name": "Bhimashankar Forest Trip Taxi Pune",
        "description": "Explore the rich biodiversity of Bhimashankar Wildlife Sanctuary en route to the temple with Meghana Cab. Our forest trip taxi services are perfect for nature lovers and photographers looking to combine pilgrimage with eco-tourism."
    },
    {
        "name": "Affordable Taxi Pune to Bhimashankar",
        "description": "Get budget-friendly taxi options from Pune to Bhimashankar with Meghana Cab. We provide transparent pricing with no hidden charges, ensuring a cost-effective and comfortable journey to the temple and back."
    },
    {
        "name": "SUV for Pune to Bhimashankar Route",
        "description": "For a spacious and smooth ride through the winding roads to Bhimashankar, choose an SUV taxi from Meghana Cab. Ideal for families or groups, our SUVs offer extra legroom and luggage space for a comfortable trip."
    },
    {
        "name": "Online Cab Pune to Bhimashankar",
        "description": "Book your cab to Bhimashankar Temple online in just a few steps. Meghana Cab’s digital booking platform lets you choose the vehicle type, view fare estimates, and confirm your ride instantly for a hassle-free experience."
    },
    {
        "name": "Pune to Bhimashankar Tour Package Cab",
        "description": "Choose Meghana Cab’s tour package for a complete Pune to Bhimashankar experience. Our packages include round trip travel, time for darshan, optional local sightseeing, and flexible return schedules tailored to your needs."
    },
    {
        "name": "Sedan Hire Pune to Bhimashankar",
        "description": "Hire a comfortable sedan cab for your Bhimashankar temple trip from Pune. Our sedans are ideal for small families or couples, offering a smooth and elegant ride through the hills with our skilled drivers."
    },
    {
        "name": "Family Cab Pune to Bhimashankar",
        "description": "Make your family pilgrimage to Bhimashankar special with Meghana Cab’s family cab services. Choose from large vehicles with comfortable seating and enjoy a peaceful drive with safe and courteous drivers."
    },
    {
        "name": "Outstation Trip to Bhimashankar from Pune",
        "description": "Planning a religious outstation trip to Bhimashankar? Meghana Cab offers specialized outstation cab services with round-the-clock support, safe vehicles, and on-time pickups from anywhere in Pune city."
    },
    {
        "name": "Chauffeur Cab Bhimashankar Pune",
        "description": "Enjoy a premium experience with our chauffeur-driven cabs to Bhimashankar. Meghana Cab’s professional drivers ensure punctuality, safety, and a pleasant journey, letting you focus entirely on your pilgrimage and the spiritual vibes of Bhimashankar."
    }
],

"tableData": [
    ["Pune to Bhimashankar Temple Cab", "Bhimashankar Darshan Taxi from Pune"],
    ["Cab Hire Pune to Bhimashankar", "One Way Taxi Pune to Bhimashankar"],
    ["Round Trip Cab Pune to Bhimashankar", "AC Cab Booking to Bhimashankar"],
    ["Bhimashankar Forest Trip Taxi Pune", "Affordable Taxi Pune to Bhimashankar"],
    ["SUV for Pune to Bhimashankar Route", "Online Cab Pune to Bhimashankar"],
    ["Pune to Bhimashankar Tour Package Cab", "Sedan Hire Pune to Bhimashankar"],
    ["Family Cab Pune to Bhimashankar", "Outstation Trip to Bhimashankar from Pune"],
    ["Chauffeur Cab Bhimashankar Pune", ""]
],









"whychoose": [
    {
        "WhyChooseheading": "Comfortable Pune to Bhimashankar Cab Service",
        "WhyChoosedescription": "Meghana Cab offers reliable and comfortable cab service from Pune to Bhimashankar, ideal for pilgrimage visits to the famous Jyotirlinga temple or exploring the lush Bhimashankar Wildlife Sanctuary. Our service ensures a smooth and stress-free journey through the scenic Western Ghats."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Enjoy competitive fares with no hidden charges. Our Pune to Bhimashankar cab packages include fuel, driver allowance, and taxes—so you get clear, all-inclusive pricing right from the start."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Hill and Ghat Routes",
        "WhyChoosedescription": "Our professional drivers are trained and experienced in navigating the winding ghat sections on the route to Bhimashankar. They prioritize safety, comfort, and time efficiency throughout the journey."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Vehicles",
        "WhyChoosedescription": "Choose from sanitized, air-conditioned sedans, SUVs, or tempo travellers depending on your group size. All vehicles are spacious and perfect for the 3–4 hour drive through hilly terrain and forested areas."
    },
    {
        "WhyChooseheading": "Flexible One-Way, Round Trip & Same-Day Return Options",
        "WhyChoosedescription": "Whether you're planning a spiritual day trip or an overnight stay, we offer one-way, round trip, and same-day return cab options to Bhimashankar to fit your schedule."
    },
    {
        "WhyChooseheading": "24/7 Availability for Early Morning Darshan Trips",
        "WhyChoosedescription": "Meghana Cab operates round-the-clock. Many travelers prefer early morning departures for temple darshan—our 24/7 service makes it easy to plan your trip anytime, even during weekends or festivals."
    },
    {
        "WhyChooseheading": "Quick Online Booking & Live Driver Tracking",
        "WhyChoosedescription": "Book your Pune to Bhimashankar cab in minutes through our website, app, or by phone. Get instant confirmation, real-time driver tracking, and customer support throughout your journey."
    },
    {
        "WhyChooseheading": "Ideal for Pilgrims, Families & Nature Lovers",
        "WhyChoosedescription": "Whether you're visiting the sacred Bhimashankar Jyotirlinga or trekking through the wildlife sanctuary, Meghana Cab ensures a safe, convenient, and enjoyable ride for every kind of traveler."
    }
]









































    }

const faqData = [
    {
        question: "How can I book a cab from Pune to Bhimashankar with Meghana Cab?",
        answer: "You can easily book a Pune to Bhimashankar cab by calling Meghana Cab at +91 9075462128 or through our website."
    },
    {
        question: "What types of vehicles are available for Pune to Bhimashankar trips?",
        answer: "We offer sedans, SUVs, and tempo travellers depending on your group size and comfort needs."
    },
    {
        question: "Are Meghana Cab drivers familiar with the Pune to Bhimashankar route?",
        answer: "Yes, our drivers know the best routes to ensure a safe and timely journey to Bhimashankar."
    },
    {
        question: "Can I book a one-way or round-trip cab from Pune to Bhimashankar?",
        answer: "Yes, both one-way and round-trip options are available."
    },
    {
        question: "What is included in the Pune to Bhimashankar cab fare?",
        answer: "The fare includes driver charges, fuel, tolls, and vehicle maintenance. Additional charges may apply based on your trip."
    },
    {
        question: "Are the vehicles sanitized for Pune to Bhimashankar trips?",
        answer: "Yes, all vehicles are regularly cleaned and sanitized for your safety and comfort."
    },
    {
        question: "Is Meghana Cab available 24/7 for Pune to Bhimashankar bookings?",
        answer: "Yes, our services operate round-the-clock to accommodate your travel schedule."
    },
    {
        question: "Can I request special requirements like child seats for Pune to Bhimashankar trips?",
        answer: "Yes, special requests can be made during booking."
    },
    {
        question: "What payment methods are accepted for Pune to Bhimashankar cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
    {
        question: "How can I contact Meghana Cab for Pune to Bhimashankar cab services?",
        answer: "Call Meghana Cab at +91 9075462128 to book or inquire about Pune to Bhimashankar cab services."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Rahul Shinde',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Pune to Bhimashankar cab service was excellent. The driver was knowledgeable and the vehicle comfortable.”',
    },
    {
        name: 'Ms. Anjali Pawar',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Highly recommend Meghana Cab for trips to Bhimashankar. Punctual and reliable service.”',
    },
];






































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Bhimashankar Cab",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-bhimashankar-cab.jpg",
  "description": "Book Pune to Bhimashankar cab with Meghana Cabs for hassle-free temple trips, forest tours, and outstation travel. Choose AC sedans, SUVs, and affordable options with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4320"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-bhimashankar-cab"
  }
};






    return (
        <div>

<Helmet>
  <title>Pune to Bhimashankar Cab | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Bhimashankar cab with Meghana Cabs for hassle-free temple trips, forest tours, and outstation travel. Choose AC sedans, SUVs, and affordable options with experienced drivers." 
  />
  <meta 
    name="keywords" 
    content="Pune to Bhimashankar Temple Cab, Bhimashankar Darshan Taxi from Pune, Cab Hire Pune to Bhimashankar, One Way Taxi Pune to Bhimashankar, Round Trip Cab Pune to Bhimashankar, AC Cab Booking to Bhimashankar, Bhimashankar Forest Trip Taxi Pune, Affordable Taxi Pune to Bhimashankar, SUV for Pune to Bhimashankar Route, Online Cab Pune to Bhimashankar, Pune to Bhimashankar Tour Package Cab, Sedan Hire Pune to Bhimashankar, Family Cab Pune to Bhimashankar, Outstation Trip to Bhimashankar from Pune, Chauffeur Cab Bhimashankar Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/36.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetobhimashankarcab;